module.exports = __webpack_public_path__ + "img/desktop-resolutions-short-lived.039b76c7.png";